export interface Planet {
  name: string;
  icon: string;
  element: string;
}

export interface Deity {
  name: string;
  image: string; // Placeholder for image path or description
}

export interface DayData {
  title: string;
  desc: string;
  icon: string;
  planet: Planet;
  deity: Deity;
  color: string;
  hColor: string; // Hex color for UI
  luckyDirection: string;
}

export const ARCHETYPES: Record<string, DayData> = {
  sunday: {
    title: "พญาครุฑ หยุดโลก",
    desc: "ร้อนแรง ดุดัน ทรงพลัง อำนาจล้นเหลือ แต่ระวังใจร้อนเกินไป เดี๋ยวจะไหม้ตัวเอง",
    icon: "🔥",
    planet: { name: "พระอาทิตย์ (๑)", icon: "☀️", element: "ไฟ" },
    deity: { name: "พระอาทิตย์", image: "Standing" },
    color: "แดง",
    hColor: "#EF4444", // red-500
    luckyDirection: "อีสาน (ตะวันออกเฉียงเหนือ)"
  },
  monday: {
    title: "นางกวัก 5G",
    desc: "เสน่ห์แรง พูดอะไรคนก็เชื่อ เหมาะกับการค้าขายหรือเป็น Influencer",
    icon: "💃",
    planet: { name: "พระจันทร์ (๒)", icon: "🌙", element: "ดิน" }, // Note: In Thai astrology Moon is often associated with Water/Earth depending on context, using classic element mappings
    deity: { name: "พระจันทร์", image: "Stopping the Ocean" },
    color: "เหลือง",
    hColor: "#EAB308", // yellow-500
    luckyDirection: "บูรพา (ตะวันออก)"
  },
  tuesday: {
    title: "หนุมาน คลุกฝุ่น",
    desc: "สู้งาน อึด ถึก ทน! ปัญหามาปัญญามี แต่ระวังเรื่องชู้สาวนะพ่อคุณ",
    icon: "⚔️",
    planet: { name: "พระอังคาร (๓)", icon: "🗡️", element: "ลม" },
    deity: { name: "พระอังคาร", image: "Reclining" },
    color: "ชมพู",
    hColor: "#EC4899", // pink-500
    luckyDirection: "อาคเนย์ (ตะวันออกเฉียงใต้)"
  },
  wednesday: {
    title: "สุนทรภู่ กูรู",
    desc: "วาจาเป็นเลิศ วิเคราะห์เก่ง ข้อมูลแน่น เอาน้ำเย็นเข้าลูบชนะทุกสิ่ง",
    icon: "📜",
    planet: { name: "พระพุธ (๔)", icon: "🐘", element: "น้ำ" },
    deity: { name: "พระพุธ", image: "Holding Alms Bowl" },
    color: "เขียว",
    hColor: "#22C55E", // green-500
    luckyDirection: "ทักษิณ (ใต้)"
  },
  thursday: {
    title: "ฤษี ไอที",
    desc: "มีความรู้ มีสติ (บางที) ชอบสอนคนอื่น เหมาะเป็นที่ปรึกษา",
    icon: "🧘",
    planet: { name: "พระพฤหัสบดี (๕)", icon: "🧘", element: "ดิน" }, // Traditional Thai Astrology Element
    deity: { name: "พระพฤหัสบดี", image: "Meditating" },
    color: "ส้ม",
    hColor: "#F97316", // orange-500
    luckyDirection: "ประจิม (ตะวันตก)"
  },
  friday: {
    title: "กินรี ขี้เล่น",
    desc: "รักสวยรักงาม สายบันเทิง ปาร์ตี้เก่ง ความสุขคือการใช้เงิน",
    icon: "🪽",
    planet: { name: "พระศุกร์ (๖)", icon: "🎨", element: "น้ำ" },
    deity: { name: "พระศุกร์", image: "Contemplating" },
    color: "ฟ้า",
    hColor: "#3B82F6", // blue-500
    luckyDirection: "อุดร (เหนือ)"
  },
  saturday: {
    title: "พญานาค พ่นไฟ",
    desc: "ลึกลับ ซับซ้อน เก็บความรู้สึกเก่ง แต่บทจะโกรธใครก็เอาไม่อยู่",
    icon: "🐉",
    planet: { name: "พระเสาร์ (๗)", icon: "🐅", element: "ไฟ" },
    deity: { name: "พระเสาร์", image: "Naga Protection" },
    color: "ม่วง",
    hColor: "#A855F7", // purple-500
    luckyDirection: "หรดี (ตะวันตกเฉียงใต้)"
  },
};

export type Day = keyof typeof ARCHETYPES;
